import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from "react-router-dom";
import { Button, Box, Text, Anchor } from 'grommet';
import AccessibleSelect from './AccessibleSelect';
import ReactTable from "react-table";
/*import data from '../Data.json';*/
import { STATOPRATICHE } from '../Constants.js';
import Pagination from './../Components/Pagination';
import { SearchPraticesCtrl } from '../Controllers/Ebox/SearchPraticesCtrl';
import ModalErrorTimeout from './ModalErrorTimeout';
import { dateConvert, loader, maskCardNumber } from '../Utils/Utility';


class GestioneRichiesteStep3 extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            dataList: !this.props.values.data || this.props.values.data.length === 0 ? [] : this.props.values.data,
            selectedOrderValue: '',
            selectedOrderLabel: '',
            selectedCode: '',
            showTimeoutModal: false,
            statepratiche: this.props.location.practicestate,
            loading: true
        }
        this.openPratiche = this.openPratiche.bind(this);
        this.setSelection = this.setSelection.bind(this);
        this.setSelectionCodeEs = this.setSelectionCodeEs.bind(this);
        this.goToSelectedRow = this.goToSelectedRow.bind(this);
        this.setSelectionMovements = this.setSelectionMovements.bind(this);

    }

    componentWillMount() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
		const self=this;
		SearchPraticesCtrl(function(data, status) {
			self.setState({
				data: data === undefined ? [] : data,
				//pagination: data.pagination,
				//status: status,
				loading:false
			});
		}, function(error) {
            self.setState({
                status: error
            }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    // pathname: '/login'
                    // })
                }
            })
		}, this.state, this.props.location.practicestate, this.props.values.gestore, token, ids);
    }

    back = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }

    openPratiche() {
        this.props.history.push({
            pathname: ''
        })
    }

    goToSelectedRow(row, e) {
        e.preventDefault();
        sessionStorage.setItem('caseId', row.original.caseId);
        sessionStorage.setItem('practiceState', this.props.location.practicestate);
        // this.props.history.push({
        //     caseId: row.caseId
        //   })
        this.props.nextStep();
    }

    setValueOrder(value) {
        if(value === "Data scadenza"){
            return 'datascad'    
        } else if(value === "PV"){
            return 'pv'
        } else if(value === "Data operazione") {
            return 'dataOp'
        } else if (value === "Importo") {
            return 'importo'
        } else if(value === "Numero carta") {
            return 'carta'
        }
    }

    setValueMovements(value) {
        // Implementazione della funzione mancante per convertire valori di movimento
        if(value === "Movimento Tipo A"){
            return 'movA'    
        } else if(value === "Movimento Tipo B"){
            return 'movB'
        } else {
            return 'movDefault'
        }
    }

    setSelection(event) {
        this.setState({
            selectedOrderLabel: event.value,
            selectedOrderValue: this.setValueOrder(event.value),
            loading: true
        }, () => {
            var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
		const self=this;
		SearchPraticesCtrl(function(data, status) {
			self.setState({
				data: data === undefined ? [] : data,
				//pagination: data.pagination,
				//status: status,
				loading:false
			});
		}, function(error) {
            self.setState({
                status: error
            }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    // pathname: '/login'
                    // })
                }
            })
		}, this.state, this.props.location.practicestate, this.props.values.gestore, token, ids);
        })
    }

    setSelectionCodeEs(event) {
        this.setState({
            selectedCode: event.value,
            loading: true
        }, () => {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
		const self=this;
		SearchPraticesCtrl(function(data, status) {
			self.setState({
				data: data === undefined ? [] : data,
				//pagination: data.pagination,
				//status: status,
				loading:false
			});
		}, function(error) {
            self.setState({
                status: error
            }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    // pathname: '/login'
                    // })
                }
            })
		}, this.state, this.props.location.practicestate, this.props.values.gestore, token, ids);
        })
    }

    setSelectionMovements(event) {
        this.setState({
            selectLabel: event.value,
            selectedMov: this.setValueMovements(event.value)
        })
    }

    

    render() {

        const hasData = (Array.isArray(this.state.data) && this.state.data.length > 0 && this.state.data !== null && this.state.data !== undefined)
        const size = hasData && this.state.data.length < 10 ? this.state.data.length : 10

        const options = [
                            "Data scadenza",
                            "PV",
                            "Data operazione",
                            "Importo",
                            "Numero carta"
                        ] 
        

        const optionsCodEs = this.state.dataList.map(code => (code.managerCode))

        const columns = [
            {
                Header: 'Scadenza',
                accessor: 'expiry',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row, i) => <Anchor id={'scadenza-' + [row.index]} onClick={this.goToSelectedRow.bind(this, row)}>{dateConvert(row.value)}</Anchor>
            },
            {
                Header: 'Codice punto vendita',
                accessor: 'codPV',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'Insegna/Località',
                accessor: 'insegnaLoc',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }

            },
            {
                Header: 'Data operazione',
                accessor: 'dataTrans',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => dateConvert(row.value)
            },
            {
                Header: 'Numero carta',
                accessor: 'card',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => maskCardNumber(row.value)

            },
            {
                Header: 'Importo transazione',
                accessor: 'amountTrans',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }

            },
            {
                Header: 'Importo contestato',
                accessor: 'amountCont',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }

            },
            {
                Header: 'N. pratica',
                accessor: 'practice',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }

            }
        ]

        return (
                   <Box className='contentbox' >
                       {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                        <Box align='start' style={{ margin: '20px 16px' }}>
                            <Text className='titlehome'><h1>{STATOPRATICHE.titleStatoPratiche} {this.state.statepratiche === "nuove" ? "NUOVE"
                                : this.state.statepratiche === "sospeso" ? "IN SOSPESO"
                                    : this.state.statepratiche === "scadenza" ? "IN SCADENZA"
                                        : this.state.statepratiche === "visione" ? "IN VISIONE"
                                            : this.state.statepratiche === "annullate" ? "ANNULLATE"
                                                : this.state.statepratiche === "evase" ? "EVASE"
                                                    : this.state.statepratiche === "chiuse" ? "CHIUSE"
                                                        : ""}</h1></Text>
                           <Text className='preline textParagraph' style={{ marginTop: '10px' }} ><h3>{STATOPRATICHE.textStatoPratiche}</h3></Text>
                        </Box>
                        <Box align='start' style={{ margin: '16px' }} id='searchpv'>
                            <Box id='test' style={{ width: '100%', marginBottom: '30px' }} direction='row' className='rowColumn' >
                                <Box style={{ marginRight: '30px' }} >
                                    <Text className='label' id='select-fields-label' htmlFor='select-fields' aria-hidden="false">ORDINA PER:</Text>
                                    <AccessibleSelect 
                                        id='select-fields'
                                        className='select'
                                        options={options}
                                        value={this.state.selectedOrderLabel}
                                        onChange={this.setSelection}
                                        aria-labelledby='select-fields-label'
                                        aria-required='true'
                                        a11yTitle='Ordina per'
                                        dropAlign={{ top: 'bottom' }}
                                        dropProps={{
                                            a11yTitle: 'Opzioni di ordinamento disponibili'
                                        }}
                                    />
                                </Box>
                                <Box >
                                    <Text className='label' id='select-code-label' htmlFor='select-code' aria-hidden="false">RICERCA PER CODICE ESERCENTE:</Text>
                                    <AccessibleSelect 
                                        id='select-code'
                                        className='select'
                                        placeholder=''
                                        options={optionsCodEs}
                                        value={this.state.selectedCode}
                                        onChange={this.setSelectionCodeEs}
                                        aria-labelledby='select-code-label'
                                        aria-required='true'
                                        a11yTitle='Ricerca per codice esercente'
                                        dropAlign={{ top: 'bottom' }}
                                        dropProps={{
                                            a11yTitle: 'Opzioni di codice esercente disponibili'
                                        }}
                                    />
                                </Box>
                            </Box>

                            {this.state.loading ? 
                                
                                loader

                                :

                                <Box style={{ width: '100%' }}>
                                    <ReactTable
                                        PaginationComponent={Pagination}
                                        data={this.state.data}
                                        columns={columns}
                                        sortable={true}
                                        multiSort={true}
                                        resizable={true}
                                        showPagination={true}
                                        loading={false}
                                        defaultPageSize={size}
                                        style={{ paddingBottom: '20px' }} />
                                </Box>
                            }
                            <Box align='center'>
                                <Button className='btnform' style={{ width: '170px', margin: '32px 30px 0 0'  }} onClick={this.back}>INDIETRO</Button>
                            </Box>
                        </Box>
                    </Box>
        )
    }
}

export default withRouter(GestioneRichiesteStep3);
